import { useNavigate, useLocation } from "react-router-dom";

// import { useState, useEffect } from "react";
import React, { useEffect, useState, useRef } from 'react';
// import { useEffect, useState, useRef } from 'react';
import Navbar from "../components/Navbar";
import axios from "axios";



const API_BASE = import.meta.env.VITE_API_BASE || "http://192.168.0.57:5000";
/* ─── CSS injected once ─── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=Montserrat:wght@300;400;500;600;700&display=swap');

  :root {
    --black: #0a0a0a;
    --deep:  #111111;
    --card:  #161616;
    --border:#2a2a2a;
    --gold:  #c9a84c;
    --gold-light:#e2c36e;
    --gold-pale: #f0d98a;
    --white: #f5f0e8;
    --grey:  #888888;
    --grey-light:#cccccc;
  }

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; }

  body {
    background: var(--black);
    color: var(--white);
    font-family: 'Montserrat', sans-serif;
    font-weight: 300;
    overflow-x: hidden;
  }

  /* ── KEYFRAMES ── */
  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(40px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  @keyframes slideInLeft {
    from { opacity: 0; transform: translateX(-50px); }
    to   { opacity: 1; transform: translateX(0); }
  }
  @keyframes slideInRight {
    from { opacity: 0; transform: translateX(50px); }
    to   { opacity: 1; transform: translateX(0); }
  }
  @keyframes shimmer {
    0%   { background-position: -200% center; }
    100% { background-position:  200% center; }
  }
  @keyframes pulse-gold {
    0%, 100% { box-shadow: 0 0 0 0 rgba(201,168,76,0); }
    50%       { box-shadow: 0 0 20px 4px rgba(201,168,76,0.18); }
  }
  @keyframes float {
    0%, 100% { transform: translateY(0px); }
    50%       { transform: translateY(-8px); }
  }
  @keyframes navBorderGlow {
    0%, 100% { border-bottom-color: var(--border); }
    50%       { border-bottom-color: rgba(201,168,76,0.25); }
  }
  @keyframes revealBar {
    from { transform: scaleX(0); }
    to   { transform: scaleX(1); }
  }
  @keyframes gridFade {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  @keyframes dotSpin {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }

  /* ── NAV ── */
  .znav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 100;
    display: flex; align-items: center; justify-content: space-between;
    padding: 0 60px; height: 70px;
    background: rgba(10,10,10,0.92);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid var(--border);
    transition: border-bottom-color 0.4s;
    animation: fadeIn 0.6s ease both;
  }
  .znav.scrolled { border-bottom-color: rgba(201,168,76,0.2); }
  .nav-logo {
    font-family: 'Cormorant Garamond', serif;
    font-size: 1.5rem; font-weight: 600; letter-spacing: 0.08em;
    color: var(--white);
    display: flex; align-items: center; gap: 10px;
    animation: slideInLeft 0.7s ease both;
  }
  .nav-logo span { color: var(--gold); }
  .nav-links { display: flex; gap: 36px; list-style: none; }
  .nav-links a {
    color: var(--grey-light); text-decoration: none;
    font-size: 0.72rem; letter-spacing: 0.15em; text-transform: uppercase;
    transition: color 0.3s;
    position: relative;
  }
  .nav-links a::after {
    content: ''; position: absolute; bottom: -3px; left: 0; right: 0;
    height: 1px; background: var(--gold);
    transform: scaleX(0); transition: transform 0.3s;
    transform-origin: left;
  }
  .nav-links a:hover::after, .nav-links a.active::after { transform: scaleX(1); }
  .nav-links a:hover, .nav-links a.active { color: var(--gold); }
  .nav-cta {
    padding: 9px 24px; border: 1px solid var(--gold);
    color: var(--gold); font-size: 0.7rem; letter-spacing: 0.18em; text-transform: uppercase;
    cursor: pointer; transition: all 0.3s; background: transparent;
    font-family: 'Montserrat', sans-serif;
    animation: slideInRight 0.7s ease both;
  }
  .nav-cta:hover {
    background: var(--gold); color: var(--black);
    animation: pulse-gold 1.5s ease infinite;
  }

  /* ── HERO ── */
  .hero {
    position: relative; min-height: 100vh;
    display: flex; align-items: center;
    padding: 120px 60px 80px; overflow: hidden;
  }
  .hero-bg {
    position: absolute; inset: 0;
    background:
      radial-gradient(ellipse 60% 80% at 70% 50%, rgba(201,168,76,0.07) 0%, transparent 70%),
      linear-gradient(160deg, #0a0a0a 0%, #111111 50%, #0d0d0d 100%);
    animation: fadeIn 1.2s ease both;
  }
  .hero-grid {
    position: absolute; inset: 0;
    background-image:
      linear-gradient(rgba(201,168,76,0.04) 1px, transparent 1px),
      linear-gradient(90deg, rgba(201,168,76,0.04) 1px, transparent 1px);
    background-size: 60px 60px;
    mask-image: radial-gradient(ellipse 70% 70% at 70% 50%, black 0%, transparent 80%);
    animation: gridFade 1.5s ease both;
  }

  .hero-content {
    position: relative; z-index: 2; flex: 1; max-width: 580px;
    animation: slideInLeft 0.9s ease both;
  }
  .hero-eyebrow {
    display: flex; align-items: center; gap: 14px; margin-bottom: 28px;
  }
  .hero-eyebrow::before {
    content: ''; display: block; width: 40px; height: 1px; background: var(--gold);
    animation: revealBar 0.8s ease 0.5s both;
    transform-origin: left;
  }
  .hero-eyebrow span {
    font-size: 0.65rem; letter-spacing: 0.3em; text-transform: uppercase; color: var(--gold);
    animation: fadeIn 0.6s ease 0.6s both; opacity: 0;
    animation-fill-mode: both;
  }
  .hero h1 {
    font-family: 'Cormorant Garamond', serif;
    font-size: clamp(3.2rem, 5vw, 5rem);
    font-weight: 300; line-height: 1.05; color: var(--white);
    margin-bottom: 24px;
    animation: fadeUp 0.8s ease 0.3s both;
  }
  .hero h1 em { font-style: italic; color: var(--gold); }
  .hero-sub {
    font-size: 0.8rem; line-height: 1.85; color: var(--grey);
    max-width: 420px; margin-bottom: 40px; letter-spacing: 0.03em;
    animation: fadeUp 0.8s ease 0.5s both;
  }
  .hero-actions {
    display: flex; gap: 16px; flex-wrap: wrap;
    animation: fadeUp 0.8s ease 0.7s both;
  }

  .btn-gold {
    padding: 14px 36px; background: var(--gold); color: var(--black);
    font-family: 'Montserrat', sans-serif;
    font-size: 0.7rem; font-weight: 600; letter-spacing: 0.2em; text-transform: uppercase;
    border: none; cursor: pointer; transition: all 0.3s;
    text-decoration: none; display: inline-block;
    position: relative; overflow: hidden;
  }
  .btn-gold::before {
    content: ''; position: absolute; inset: 0;
    background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.2) 50%, transparent 100%);
    background-size: 200% 100%;
    transform: translateX(-100%);
    transition: transform 0s;
  }
  .btn-gold:hover { background: var(--gold-pale); transform: translateY(-2px); box-shadow: 0 8px 24px rgba(201,168,76,0.25); }
  .btn-gold:hover::before { animation: shimmer 0.7s ease; }

  .btn-outline {
    padding: 14px 36px; background: transparent;
    border: 1px solid var(--border); color: var(--grey-light);
    font-family: 'Montserrat', sans-serif;
    font-size: 0.7rem; letter-spacing: 0.2em; text-transform: uppercase;
    cursor: pointer; transition: all 0.3s;
    text-decoration: none; display: inline-block;
  }
  .btn-outline:hover { border-color: var(--gold); color: var(--gold); transform: translateY(-2px); }

  /* ── BOOKING CARD ── */
  .hero-form-wrap {
    position: relative; z-index: 2; margin-left: auto; flex-shrink: 0; width: 400px;
    animation: slideInRight 0.9s ease 0.2s both;
  }
  .booking-card {
    background: var(--card); border: 1px solid var(--border);
    padding: 36px; position: relative;
    transition: box-shadow 0.4s;
  }
  .booking-card:hover { box-shadow: 0 0 40px rgba(201,168,76,0.06); }
  .booking-card::before {
    content: ''; position: absolute; top: 0; left: 0; right: 0; height: 2px;
    background: linear-gradient(90deg, transparent, var(--gold), transparent);
    animation: shimmer 3s ease infinite;
    background-size: 200% 100%;
  }
  .booking-card-title {
    font-family: 'Cormorant Garamond', serif;
    font-size: 1.5rem; font-weight: 400; color: var(--white); margin-bottom: 6px;
  }
  .booking-card-sub {
    font-size: 0.65rem; letter-spacing: 0.15em; text-transform: uppercase;
    color: var(--gold); margin-bottom: 28px;
  }

  .trip-toggle { display: flex; margin-bottom: 24px; }
  .trip-toggle button {
    flex: 1; padding: 10px; background: transparent; border: 1px solid var(--border);
    color: var(--grey); cursor: pointer;
    font-family: 'Montserrat', sans-serif;
    font-size: 0.68rem; letter-spacing: 0.12em; text-transform: uppercase;
    transition: all 0.25s;
  }
  .trip-toggle button:first-child { border-right: none; }
  .trip-toggle button.active {
    background: var(--gold); border-color: var(--gold);
    color: var(--black); font-weight: 600;
  }

  .form-field { margin-bottom: 16px; }
  .form-field label {
    display: block; font-size: 0.6rem; letter-spacing: 0.2em; text-transform: uppercase;
    color: var(--grey); margin-bottom: 6px;
  }
  .form-field input, .form-field select {
    width: 100%; padding: 11px 14px;
    background: #1a1a1a; border: 1px solid var(--border);
    color: var(--white); font-family: 'Montserrat', sans-serif;
    font-size: 0.78rem; outline: none; transition: border-color 0.25s, box-shadow 0.25s;
    -webkit-appearance: none; appearance: none;
  }
  .form-field input::placeholder { color: #444; }
  .form-field input:focus, .form-field select:focus {
    border-color: var(--gold);
    box-shadow: 0 0 0 2px rgba(201,168,76,0.1);
  }
  .form-field select {
    cursor: pointer;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23c9a84c'/%3E%3C/svg%3E");
    background-repeat: no-repeat; background-position: right 14px center; padding-right: 36px;
  }
  .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
  .pax-field { display: flex; align-items: center; }
  .pax-field input { text-align: center; flex: 1; }
  .pax-btn {
    width: 38px; height: 38px; border: 1px solid var(--border);
    background: #1a1a1a; color: var(--gold); font-size: 1.1rem;
    cursor: pointer; display: flex; align-items: center; justify-content: center;
    transition: all 0.2s; flex-shrink: 0;
  }
  .pax-btn:hover { background: var(--gold); color: var(--black); border-color: var(--gold); transform: scale(1.05); }
  .pax-btn:first-child { border-right: none; }
  .pax-btn:last-child { border-left: none; }
  .form-submit {
    width: 100%; padding: 14px; background: var(--gold); border: none; color: var(--black);
    font-family: 'Montserrat', sans-serif;
    font-size: 0.72rem; font-weight: 700; letter-spacing: 0.25em; text-transform: uppercase;
    cursor: pointer; margin-top: 8px; transition: all 0.3s; position: relative; overflow: hidden;
  }
  .form-submit:hover { background: var(--gold-pale); letter-spacing: 0.3em; }
  .form-submit:active { transform: scale(0.98); }

  /* ── DIVIDER ── */
  .gold-divider {
    display: flex; align-items: center; gap: 16px; padding: 0 60px; margin: 0;
  }
  .gold-divider::before, .gold-divider::after {
    content: ''; flex: 1; height: 1px; background: var(--border);
  }
  .gold-divider-icon {
    width: 8px; height: 8px; background: var(--gold);
    transform: rotate(45deg);
    animation: dotSpin 4s linear infinite;
  }

  /* ── SECTION HEADER ── */
  .section-header { text-align: center; padding: 80px 60px 0; }
  .section-eyebrow {
    font-size: 0.63rem; letter-spacing: 0.35em; text-transform: uppercase;
    color: var(--gold); margin-bottom: 14px;
  }
  .section-title {
    font-family: 'Cormorant Garamond', serif;
    font-size: clamp(2.2rem, 3.5vw, 3.2rem); font-weight: 300;
    color: var(--white); line-height: 1.15; margin-bottom: 16px;
  }
  .section-desc {
    font-size: 0.78rem; color: var(--grey); line-height: 1.85;
    max-width: 680px; margin: 0 auto;
  }

  /* ── FEATURES ── */
  .features {
    display: grid; grid-template-columns: repeat(4,1fr);
    gap: 1px; background: var(--border); margin: 60px 60px 0;
  }
  .feature-card {
    background: var(--deep); padding: 40px 28px;
    transition: background 0.3s, transform 0.3s;
    position: relative; overflow: hidden;
    opacity: 0;
  }
  .feature-card.visible {
    animation: fadeUp 0.6s ease forwards;
  }
  .feature-card::after {
    content: ''; position: absolute; bottom: 0; left: 0; right: 0; height: 2px;
    background: var(--gold); transform: scaleX(0); transition: transform 0.4s;
    transform-origin: left;
  }
  .feature-card:hover { background: #141414; transform: translateY(-2px); }
  .feature-card:hover::after { transform: scaleX(1); }
  .feature-icon {
    width: 52px; height: 52px; margin-bottom: 24px;
    border: 1px solid var(--border);
    display: flex; align-items: center; justify-content: center; font-size: 1.4rem;
    transition: border-color 0.3s, transform 0.3s;
  }
  .feature-card:hover .feature-icon { border-color: var(--gold); transform: scale(1.05) rotate(-3deg); }
  .feature-title {
    font-family: 'Cormorant Garamond', serif;
    font-size: 1.25rem; font-weight: 400; color: var(--white); margin-bottom: 10px;
  }
  .feature-desc { font-size: 0.72rem; color: var(--grey); line-height: 1.75; }

  /* ── VEHICLES ── */
  .vehicles-section { padding: 80px 60px 0; }
  .vehicles-grid {
    display: grid; grid-template-columns: repeat(4,1fr);
    gap: 1px; background: var(--border); margin-top: 50px;
  }
  .vehicle-card {
    background: var(--deep); transition: background 0.3s; cursor: pointer;
    position: relative; overflow: hidden;
    // opacity: 0;
  }
  .vehicle-card.visible {
    animation: fadeUp 0.6s ease forwards;
  }
  .vehicle-card:hover { background: var(--card); }
  .vehicle-img {
    width: 100%; height: 160px; background: #1a1a1a;
    display: flex; align-items: center; justify-content: center;
    overflow: hidden; position: relative;
  }
  .vehicle-img img {
    width: 100%; height: 100%; object-fit: cover;
    filter: grayscale(40%) brightness(0.8); transition: all 0.5s;
  }
  .vehicle-card:hover .vehicle-img img {
    filter: grayscale(0%) brightness(1); transform: scale(1.06);
  }
  .vehicle-img-placeholder { font-size: 3rem; color: var(--border); }
  .vehicle-info { padding: 22px 22px 28px; }
  .vehicle-name {
    font-family: 'Cormorant Garamond', serif;
    font-size: 1.3rem; color: var(--white); margin-bottom: 6px;
  }
  .vehicle-type {
    font-size: 0.6rem; letter-spacing: 0.2em; text-transform: uppercase;
    color: var(--grey); margin-bottom: 14px;
  }
  .vehicle-price { display: flex; align-items: baseline; gap: 6px; }
  .vehicle-price .from { font-size: 0.6rem; color: var(--grey); text-transform: uppercase; letter-spacing: 0.1em; }
  .vehicle-price strong {
    font-family: 'Cormorant Garamond', serif; font-size: 1.6rem;
    color: var(--gold); font-weight: 400;
  }
  .vehicle-price small { font-size: 0.6rem; color: var(--grey); }
  .vehicle-tag {
    position: absolute; top: 14px; left: 14px; padding: 3px 10px;
    background: rgba(201,168,76,0.15); border: 1px solid rgba(201,168,76,0.3);
    font-size: 0.55rem; letter-spacing: 0.15em; text-transform: uppercase; color: var(--gold);
  }

  /* ── CTA BAND ── */
  .cta-band {
    margin: 80px 60px 0; padding: 70px 60px;
    background: var(--card); border: 1px solid var(--border);
    display: flex; align-items: center; justify-content: space-between; gap: 40px;
    position: relative; overflow: hidden;
    transition: border-color 0.4s;
  }
  .cta-band:hover { border-color: rgba(201,168,76,0.25); }
  .cta-band::before {
    content: ''; position: absolute; inset: 0;
    background: radial-gradient(ellipse 50% 100% at 20% 50%, rgba(201,168,76,0.05) 0%, transparent 70%);
    pointer-events: none;
  }
  .cta-band-text { position: relative; }
  .cta-band-label {
    font-size: 0.6rem; letter-spacing: 0.3em; text-transform: uppercase;
    color: var(--gold); margin-bottom: 10px;
  }
  .cta-band-title {
    font-family: 'Cormorant Garamond', serif;
    font-size: 2.5rem; font-weight: 300; color: var(--white);
    line-height: 1.15; margin-bottom: 6px;
  }
  .cta-band-title em { font-style: italic; color: var(--gold); }
  .cta-band-sub { font-size: 0.75rem; color: var(--grey); }
  .cta-band-actions { display: flex; gap: 14px; flex-shrink: 0; align-items: center; }
  .whatsapp-btn {
    display: flex; align-items: center; gap: 10px; padding: 14px 28px;
    background: transparent; border: 1px solid #25D366; color: #25D366;
    font-family: 'Montserrat', sans-serif;
    font-size: 0.68rem; letter-spacing: 0.15em; text-transform: uppercase;
    cursor: pointer; transition: all 0.3s; text-decoration: none;
  }
  .whatsapp-btn:hover { background: #25D366; color: var(--black); transform: translateY(-2px); }

  /* ── BOOKING TYPES ── */
  .booking-types { padding: 80px 60px; }
  .booking-types-grid {
    display: grid; grid-template-columns: repeat(3,1fr);
    gap: 1px; background: var(--border); margin-top: 50px;
  }
  .booking-type-card {
    background: var(--deep); overflow: hidden; cursor: pointer;
    transition: background 0.3s; position: relative;
    opacity: 0;
  }
  .booking-type-card.visible {
    animation: fadeUp 0.7s ease forwards;
  }
  .booking-type-card:hover { background: var(--card); }
  .bt-img { height: 200px; overflow: hidden; position: relative; background: #1a1a1a; }
  .bt-img img {
    width: 100%; height: 100%; object-fit: cover;
    filter: grayscale(60%) brightness(0.5); transition: all 0.5s;
  }
  .booking-type-card:hover .bt-img img { filter: grayscale(20%) brightness(0.6); transform: scale(1.06); }
  .bt-img-overlay {
    position: absolute; inset: 0;
    background: linear-gradient(to top, rgba(10,10,10,0.7) 0%, transparent 60%);
  }
  .bt-body { padding: 30px 30px 36px; }
  .bt-icon { font-size: 1.6rem; margin-bottom: 16px; display: block; }
  .bt-title {
    font-family: 'Cormorant Garamond', serif;
    font-size: 1.5rem; color: var(--white); margin-bottom: 10px;
  }
  .bt-desc { font-size: 0.73rem; color: var(--grey); line-height: 1.75; margin-bottom: 20px; }
  .bt-link {
    font-size: 0.62rem; letter-spacing: 0.2em; text-transform: uppercase;
    color: var(--gold); text-decoration: none;
    display: flex; align-items: center; gap: 8px;
  }
  .bt-link::after { content: '→'; transition: transform 0.3s; display: inline-block; }
  .booking-type-card:hover .bt-link::after { transform: translateX(5px); }

  /* ── FOOTER ── */
  footer {
    border-top: 1px solid var(--border);
    padding: 60px 60px 30px; margin-top: 0;
  }
  .footer-grid { display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 50px; margin-bottom: 50px; }
  .footer-brand-name {
    font-family: 'Cormorant Garamond', serif;
    font-size: 1.6rem; font-weight: 400; color: var(--white); margin-bottom: 12px;
  }
  .footer-brand-name span { color: var(--gold); }
  .footer-desc { font-size: 0.72rem; color: var(--grey); line-height: 1.8; max-width: 280px; margin-bottom: 24px; }
  .footer-contact { font-size: 0.72rem; color: var(--grey); line-height: 2; }
  .footer-contact a { color: var(--gold); text-decoration: none; }
  .footer-col-title {
    font-size: 0.6rem; letter-spacing: 0.25em; text-transform: uppercase;
    color: var(--gold); margin-bottom: 22px;
  }
  .footer-links { list-style: none; }
  .footer-links li { margin-bottom: 12px; }
  .footer-links a { font-size: 0.73rem; color: var(--grey); text-decoration: none; transition: color 0.2s; }
  .footer-links a:hover { color: var(--white); }
  .socials { display: flex; gap: 10px; margin-top: 24px; }
  .social-icon {
    width: 34px; height: 34px; border: 1px solid var(--border);
    display: flex; align-items: center; justify-content: center;
    color: var(--grey); font-size: 0.75rem; text-decoration: none;
    transition: all 0.25s;
  }
  .social-icon:hover { border-color: var(--gold); color: var(--gold); transform: translateY(-2px); }
  .footer-bottom {
    border-top: 1px solid var(--border); padding-top: 26px;
    display: flex; justify-content: space-between; align-items: center;
  }
  .footer-copy { font-size: 0.62rem; color: #444; letter-spacing: 0.08em; }
  .footer-powered { font-size: 0.62rem; color: #333; }
  .footer-powered strong { color: var(--gold); }

  /* ── RESPONSIVE ── */
  @media (max-width: 1100px) {
    .znav { padding: 0 30px; }
    .hero { padding: 120px 30px 80px; flex-direction: column; gap: 50px; align-items: flex-start; }
    .hero-form-wrap { width: 100%; margin-left: 0; }
    .features, .vehicles-grid { grid-template-columns: repeat(2,1fr); margin: 40px 30px 0; }
    .vehicles-section, .booking-types { padding: 60px 30px; }
    .cta-band { margin: 60px 30px 0; flex-direction: column; align-items: flex-start; padding: 40px; }
    .booking-types-grid { grid-template-columns: 1fr; }
    footer { padding: 50px 30px 24px; }
    .footer-grid { grid-template-columns: 1fr 1fr; gap: 36px; }
    .gold-divider { padding: 0 30px; }
    .section-header { padding: 60px 30px 0; }
  }
  @media (max-width: 700px) {
    .znav { padding: 0 20px; }
    .nav-links { display: none; }
    .hero { padding: 100px 20px 60px; }
    .features { grid-template-columns: 1fr; margin: 30px 20px 0; }
    .vehicles-grid { grid-template-columns: 1fr 1fr; margin: 30px 20px 0; }
    .vehicles-section, .booking-types { padding: 50px 20px; }
    .cta-band { margin: 50px 20px 0; padding: 30px 24px; }
    .footer-grid { grid-template-columns: 1fr; }
    footer { padding: 40px 20px 20px; }
    .section-header { padding: 50px 20px 0; }
    .gold-divider { padding: 0 20px; }
  }
`;

/* ─── useScrollReveal hook ─── */
function useScrollReveal(selector) {
  useEffect(() => {
    const els = document.querySelectorAll(selector);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            setTimeout(() => entry.target.classList.add("visible"), i * 120);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [selector]);
}

/* ─── NAV ─── */
// function Nav() {
//   const [scrolled, setScrolled] = useState(false);
//   useEffect(() => {
//     const fn = () => setScrolled(window.scrollY > 60);
//     window.addEventListener("scroll", fn);
//     return () => window.removeEventListener("scroll", fn);
//   }, []);
//   const links = ["Home", "Book a Taxi", "Vehicles", "About Us", "Testimonial", "FAQ", "Contact"];
//   return (
//     <nav className={`znav${scrolled ? " scrolled" : ""}`}>
//       <div className="nav-logo">✈ Zanzibar<span>Transfer</span></div>
//       <ul className="nav-links">
//         {links.map((l, i) => (
//           <li key={l}><a href="#" className={i === 0 ? "active" : ""}>{l}</a></li>
//         ))}
//       </ul>
//       <button className="nav-cta">Book Now</button>
//     </nav>
//   );
// }

/* 
/* ─── BOOKING FORM ─── */
// const GOOGLE_MAPS_KEY = "AIzaSyCzQLn4ovNjZyXJgmS0_N7YOHD3eMiJvjs"; // your existing key

// function useGooglePlacesAutocomplete(inputRef, onPlaceSelected) {
//   useEffect(() => {
//     // Load script only once
//     const scriptId = "google-maps-places";
//     const initFn   = "__initGooglePlaces";

//     const attach = () => {
//       if (!window.google || !inputRef.current) return;
//       const zanzibarBounds = new window.google.maps.LatLngBounds(
//         new window.google.maps.LatLng(-6.5, 39.0),
//         new window.google.maps.LatLng(-5.5, 39.8)
//       );
//       const ac = new window.google.maps.places.Autocomplete(inputRef.current, {
//         componentRestrictions: { country: "TZ" },
//         bounds: zanzibarBounds,
//         strictBounds: true,
//         fields: ["geometry", "name", "formatted_address"],
//       });
//       ac.addListener("place_changed", () => {
//         const place = ac.getPlace();
//         if (place && place.geometry) onPlaceSelected(place);
//       });
//     };

//     if (window.google) {
//       attach();
//       return;
//     }

//     if (!document.getElementById(scriptId)) {
//       window[initFn] = () => {
//         document.querySelectorAll("[data-gac-pending]").forEach(el => {
//           el.dispatchEvent(new Event("gac-ready"));
//         });
//       };
//       const script = document.createElement("script");
//       script.id  = scriptId;
//       script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_KEY}&libraries=places&callback=${initFn}`;
//       script.async = true;
//       document.head.appendChild(script);
//     }

//     if (inputRef.current) {
//       inputRef.current.setAttribute("data-gac-pending", "1");
//       const handler = () => { attach(); inputRef.current?.removeAttribute("data-gac-pending"); };
//       inputRef.current.addEventListener("gac-ready", handler);
//       return () => inputRef.current?.removeEventListener("gac-ready", handler);
//     }
//   }, []);
// }

function useLocationSearch(setResults) {

  const searchLocation = async (query) => {

    if (query.length < 3) {
      setResults([]);
      return;
    }

    try {

      const res = await axios.get(
        "https://nominatim.openstreetmap.org/search",
        {
          params: {
            q: query,
            format: "json",
            addressdetails: 1,
            limit: 5,
          },
        }
      );

      setResults(res.data);

    } catch (err) {
      console.log(err);
    }
  };

  return searchLocation;
}


function BookingForm() {
  const location = useLocation();
  const navigate = useNavigate();

  const [tripType, setTripType] = useState("one");
  const [pax, setPax] = useState(1);

  const [pickupDate, setPickupDate] = useState("");
  const [returnDate, setReturnDate] = useState("");

  const [pickupTime, setPickupTime] = useState("10:00");
  const [returnTime, setReturnTime] = useState("10:00");

  const [pickupText, setPickupText] = useState("");
  const [dropText, setDropText] = useState("");

  const [pickupPlace, setPickupPlace] = useState(null);
  const [dropPlace, setDropPlace] = useState(null);

  const [pickupResults, setPickupResults] = useState([]);
  const [dropResults, setDropResults] = useState([]);

  const [distLoading, setDistLoading] = useState(false);

  const isReturn = tripType === "two";

  const searchPickup = useLocationSearch(setPickupResults);
  const searchDrop = useLocationSearch(setDropResults);

  const TIMES = [
    "06:00","07:00","08:00","09:00","10:00",
    "11:00","12:00","13:00","14:00","15:00",
    "16:00","17:00","18:00","19:00","20:00",
    "21:00","22:00"
  ];

  useEffect(() => {
    if (location.state) {
  
      setPickupText(location.state.pickupLocation || "");
      setDropText(location.state.dropLocation || "");
  
      setPickupDate(location.state.pickupDate || "");
      setReturnDate(location.state.returnDate || "");
  
      setPickupTime(location.state.pickupTime || "10:00");
      setReturnTime(location.state.returnTime || "10:00");
  
      setPax(location.state.passengers || 1);
  
      setTripType(location.state.oneway === "2" ? "two" : "one");
    }
  }, [location.state]);

  const handleSubmit = async () => {

    if (!pickupText.trim()) {
      alert("Please enter a Pickup location.");
      return;
    }

    if (!dropText.trim()) {
      alert("Please enter a Drop-off location.");
      return;
    }

    if (!pickupDate) {
      alert("Please fill the Pickup date.");
      return;
    }

    if (!pickupPlace || !dropPlace) {
      alert("Please select locations from suggestions.");
      return;
    }

    if (isReturn) {

      if (!returnDate) {
        alert("Please fill the Return date.");
        return;
      }

      const today = new Date();
      today.setHours(0,0,0,0);

      const pickup = new Date(pickupDate);
      const ret = new Date(returnDate);

      if (pickup < today) {
        alert("Pickup Date should not be less than current date");
        return;
      }

      if (ret < today) {
        alert("Return Date should not be less than current date");
        return;
      }

      if (ret < pickup) {
        alert("Return Date should not be less than Pickup Date");
        return;
      }
    }

    let totalkm = 0;

    try {

      setDistLoading(true);

      const url =
        `https://router.project-osrm.org/route/v1/driving/` +
        `${pickupPlace.lon},${pickupPlace.lat};` +
        `${dropPlace.lon},${dropPlace.lat}` +
        `?overview=false`;

      const res = await axios.get(url);

      totalkm = (
        res.data.routes[0].distance / 1000
      ).toFixed(2);

    } catch (err) {

      console.log(err);
      alert("Unable to calculate distance.");

    } finally {

      setDistLoading(false);

    }

    navigate("/transfer-step2", {
      state: {
        pickupLocation: pickupText.trim(),
        dropLocation: dropText.trim(),
        pickupDate,
        returnDate: isReturn ? returnDate : null,
        pickupTime,
        returnTime: isReturn ? returnTime : null,
        passengers: pax,
        oneway: isReturn ? "2" : "1",
        totalkm,
      }
    });
  };


  return (
    <div className="hero-form-wrap">
      <div className="booking-card">
        <div className="booking-card-title">Reserve Your Transfer</div>
        <div className="booking-card-sub">Instant booking · No hidden fees</div>

        <div className="trip-toggle">
          <button
            className={!isReturn ? "active" : ""}
            onClick={() => { setTripType("one"); setReturnDate(""); }}
          >One Way</button>
          <button
            className={isReturn ? "active" : ""}
            onClick={() => setTripType("two")}
          >Two Way</button>
        </div>

        <div className="form-field">
          <label>Pickup Location</label>
          <div style={{ position: "relative" }}>

  <input
    type="text"
    placeholder="Enter pickup location"
    value={pickupText}
    onChange={(e) => {
      setPickupText(e.target.value);
      searchPickup(e.target.value);
    }}
  />

  {pickupResults.length > 0 && (
    <div
      style={{
        position: "absolute",
        width: "100%",
        background: "#1a1a1a",
        border: "1px solid #333",
        zIndex: 999,
        maxHeight: "200px",
        overflowY: "auto",
      }}
    >
      {pickupResults.map((item, index) => (
        <div
          key={index}
          style={{
            padding: "10px",
            cursor: "pointer",
            borderBottom: "1px solid #222",
          }}
          onClick={() => {

            setPickupText(item.display_name);

            setPickupPlace({
              lat: item.lat,
              lon: item.lon,
            });

            setPickupResults([]);

          }}
        >
          {item.display_name}
        </div>
      ))}
    </div>
  )}

</div>
        </div>
        <div className="form-field">
          <label>Drop-off Location</label>
          <div style={{ position: "relative" }}>

<input
  type="text"
  placeholder="Enter drop location"
  value={dropText}
  onChange={(e) => {
    setDropText(e.target.value);
    searchDrop(e.target.value);
  }}
/>

{dropResults.length > 0 && (
  <div
    style={{
      position: "absolute",
      width: "100%",
      background: "#1a1a1a",
      border: "1px solid #333",
      zIndex: 999,
      maxHeight: "200px",
      overflowY: "auto",
    }}
  >
    {dropResults.map((item, index) => (
      <div
        key={index}
        style={{
          padding: "10px",
          cursor: "pointer",
          borderBottom: "1px solid #222",
        }}
        onClick={() => {

          setDropText(item.display_name);

          setDropPlace({
            lat: item.lat,
            lon: item.lon,
          });

          setDropResults([]);

        }}
      >
        {item.display_name}
      </div>
    ))}
  </div>
)}

</div>
        </div>

        {/* ── Pickup Date + Time ── */}
        <div className="form-row">
          <div className="form-field">
            <label>Pickup Date</label>
            <input
              type="date"
              value={pickupDate}
              onChange={e => setPickupDate(e.target.value)}
              min={new Date().toISOString().split("T")[0]}
            />
          </div>
          <div className="form-field">
          <label>Pickup Time</label>
            <select value={pickupTime} onChange={e => setPickupTime(e.target.value)}>
              {TIMES.map(t => <option key={t}>{t}</option>)}
            </select>
          </div>
        </div>

        {/* ── Return Date + Time (Two Way only) ── */}
        <div
          style={{
            overflow: "hidden",
            maxHeight: isReturn ? "120px" : "0",
            opacity:   isReturn ? 1 : 0,
            transition: "max-height 0.35s ease, opacity 0.3s ease",
          }}
        >
          <div className="form-row">
            <div className="form-field">
              <label>Return Date</label>
              <input
                type="date"
                value={returnDate}
                onChange={e => setReturnDate(e.target.value)}
                min={pickupDate || new Date().toISOString().split("T")[0]}
              />
            </div>
            <div className="form-field">
            <label>Return Time</label>
              <select value={returnTime} onChange={e => setReturnTime(e.target.value)}>
                {TIMES.map(t => <option key={t}>{t}</option>)}
              </select>
            </div>
          </div>
        </div>

        <div className="form-field">
          <label>Passengers</label>
          <div className="pax-field">
            <button className="pax-btn" onClick={() => setPax(p => Math.max(1, p - 1))}>−</button>
            <input type="number" value={pax} readOnly />
            <button className="pax-btn" onClick={() => setPax(p => p + 1)}>+</button>
          </div>
        </div>

        {/* <button className="form-submit" onClick={handleSubmit}>Search Transfers</button> */}
        <button
          className="form-submit"
          onClick={handleSubmit}
          disabled={distLoading}
        >
          {distLoading
            ? "Calculating Distance..."
            : "Search Transfers"}
        </button>
      </div>
    </div>
  );
}

/* ─── HERO ─── */
function Hero() {
  return (
    <section className="hero">
      <div className="hero-bg" />
      <div className="hero-grid" />
      <div className="hero-content">
        <div className="hero-eyebrow"><span>Zanzibar Airport Pickup</span></div>
        <h1>Quick, Reliable<br />& <em>Flexible</em> Booking</h1>
        <p className="hero-sub">
          We are a popular Travel Agency in Zanzibar, providing the most reliable Airport Pickup for your transfer service.
          Book a taxi transfer service from your trusted travel partner at an affordable cost.
        </p>
        <div className="hero-actions">
          <a href="#" className="btn-gold">Book a Taxi</a>
          <a href="#" className="btn-outline">Our Vehicles</a>
        </div>
      </div>
      <BookingForm />
    </section>
  );
}

/* ─── FEATURES ─── */
const FEATURES = [
  { icon: "💰", title: "Lowest Transfer Rate", desc: "Our Transfer Booking cost is very transparent with the lowest Kilometer price on the island." },
  { icon: "🛡️", title: "Secure Travel", desc: "Hire a local taxi for your Transfer and experience a safe journey with our fully insured vehicles." },
  { icon: "🕐", title: "24/7 Transfer Service", desc: "We provide a 24/7 transfer service with professional and trusted drivers for your worry-free travel." },
  { icon: "⭐", title: "Customer Reviews", desc: "We stand with our vast customer reviews and ratings in transfer service in Zanzibar." },
];
function Features() {
  useScrollReveal(".feature-card");
  return (
    <div className="features">
      {FEATURES.map(f => (
        <div className="feature-card" key={f.title}>
          <div className="feature-icon">{f.icon}</div>
          <div className="feature-title">{f.title}</div>
          <div className="feature-desc">{f.desc}</div>
        </div>
      ))}
    </div>
  );
}

// const CAR_IMG_BASE = "https://orieshop.com/admin/assets/images/cars/"; // ← adjust to your actual path
// const CAR_IMG_BASE = `${API_BASE}/images/CarImage/`;
function Vehicles() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading]   = useState(true);

  const visibleCount = 3;
  const total = vehicles.length;

  const extended = total > 0
    ? [...vehicles.slice(-visibleCount), ...vehicles, ...vehicles.slice(0, visibleCount)]
    : [];
  const offset = visibleCount;

  const [index, setIndex]           = useState(offset);
  const [transitioning, setTransitioning] = useState(true);
  const trackRef = useRef(null);

  // Fetch from API on mount — no km needed, just show all transfer cars
  useEffect(() => {
    // axios.get("/api/transfer/cars", { params: { totalkm: 10, oneway: "1" } })
    axios.get(`${API_BASE}/api/transfer/cars`, { params: { totalkm: 10, oneway: "1" } })
      .then(res => {
        if (res.data?.cars?.length) {
          setVehicles(res.data.cars);
        }
      })
      .catch(err => console.error("Vehicles fetch error:", err))
      .finally(() => setLoading(false));
  }, []);

  // Reset index when vehicles load
  useEffect(() => {
    setIndex(offset);
  }, [vehicles]);

  const goTo = (newIndex) => { setTransitioning(true); setIndex(newIndex); };
  const prev = () => goTo(index - 1);
  const next = () => goTo(index + 1);

  useEffect(() => {
    if (total === 0) return;
    const timer = setInterval(() => next(), 3000);
    return () => clearInterval(timer);
  }, [index, total]);

  const handleTransitionEnd = () => {
    if (index <= offset - 1) {
      setTransitioning(false);
      setIndex(total + offset - 1);
    } else if (index >= total + offset) {
      setTransitioning(false);
      setIndex(offset);
    }
  };

  useEffect(() => {
    if (!transitioning) {
      const t = setTimeout(() => setTransitioning(true), 20);
      return () => clearTimeout(t);
    }
  }, [transitioning]);

  const cardWidthPercent = 100 / visibleCount;
  const translateX = -(index * cardWidthPercent);

  if (loading) return (
    <div className="vehicles-section">
      <div style={{ textAlign: 'center', padding: '60px 0', color: 'var(--gold)', fontSize: 14, letterSpacing: '0.2em' }}>
        LOADING FLEET...
      </div>
    </div>
  );

  if (total === 0) return null;

  return (
    <div className="vehicles-section">
      <div className="section-header" style={{ padding: 0, textAlign: "center" }}>
        <div className="section-eyebrow">Fleet</div>
        <h2 className="section-title">Our Vehicles for<br />Zanzibar Airport Pickup</h2>
        <p className="section-desc">Taxi or Cabs for your reliable transfer around Zanzibar Island</p>
      </div>

      <div style={{ position: 'relative', overflow: 'hidden', width: '100%', minHeight: 320, marginTop: 50 }}>
        <div
          ref={trackRef}
          onTransitionEnd={handleTransitionEnd}
          style={{
            display: 'flex',
            transform: `translateX(${translateX}%)`,
            transition: transitioning ? 'transform 0.5s ease' : 'none',
            willChange: 'transform',
          }}
        >
          {extended.map((v, i) => (
            <div
              key={i}
              style={{ minWidth: `${cardWidthPercent}%`, boxSizing: 'border-box', padding: '0 10px', flexShrink: 0 }}
            >
              <div className="vehicle-card visible" style={{ opacity: 1 }}>
                <div className="vehicle-img">
                  <img
                  src={`${API_BASE}/${v.car_image}`}
                    // src={`${API_BASE}/${v.car_image}`}
                    alt={v.car_name}
                    onError={e => {
                      e.target.style.display = "none";
                      e.target.parentElement.innerHTML = `<div class="vehicle-img-placeholder">🚗</div>`;
                    }}
                  />
                </div>
                <div className="vehicle-info">
                  <div className="vehicle-name">{v.car_name}</div>
                  <div className="vehicle-type">
                    Up to {v.passengers} pax · {v.luggage} luggage
                  </div>
                  <div className="vehicle-price">
                    <span className="from">From</span>
                    <strong>${v.base_price}</strong>
                    {/* <small>/ KM</small> */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <button onClick={prev} style={{ position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)', zIndex: 10, background: '#1a6eb5', color: '#fff', border: 'none', borderRadius: '50%', width: 40, height: 40, fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>‹</button>
        <button onClick={next} style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)', zIndex: 10, background: '#1a6eb5', color: '#fff', border: 'none', borderRadius: '50%', width: 40, height: 40, fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>›</button>
      </div>
    </div>
  );
}

/* ─── CTA BAND ─── */
function CTABand() {
  return (
    <div className="cta-band">
      <div className="cta-band-text">
        <div className="cta-band-label">Direct Contact</div>
        <div className="cta-band-title">Book a Taxi at<br />Zanzibar Airport via <em>WhatsApp</em></div>
        <div className="cta-band-sub">+255 745 593 330 · Available 24/7 for instant bookings</div>
      </div>
      <div className="cta-band-actions">
        <a href="https://wa.me/255745593330" className="whatsapp-btn">
          <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
          WhatsApp Now
        </a>
        <a href="#" className="btn-gold">Book Online</a>
      </div>
    </div>
  );
}

/* ─── BOOKING TYPES ─── */
const BOOKING_TYPES = [
  { icon: "👥", title: "Group Transfer Booking", link: "Book Group Transfer",
    img: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=600&q=70",
    desc: "We provide private, air-conditioned minibuses and vans at Zanzibar Airport for groups of over 10 people. Our rates are very affordable, making it easy for you to travel comfortably." },
  { icon: "🚗", title: "Private Transfer Booking", link: "Book Private Transfer",
    img: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=600&q=70",
    desc: "Our point-to-point service from Zanzibar Airport to hotels and various locations on the island is the best way to travel in Zanzibar. No hidden fees, clear pricing, smooth and hassle-free." },
  { icon: "👨‍👩‍👧‍👦", title: "Family Transfer Booking", link: "Book Family Transfer",
    img: "https://images.unsplash.com/photo-1536098561742-ca998e48cbcc?w=600&q=70",
    desc: "We offer family-friendly private transfers in Zanzibar from ZNZ to all popular locations and hotels on the island. Our wide range of vehicles is perfect for family transfers." },
];
function BookingTypes() {
  useScrollReveal(".booking-type-card");
  return (
    <div className="booking-types">
      <div className="section-header" style={{ padding: 0, textAlign: "center" }}>
        <div className="section-eyebrow">Transfer Categories</div>
        <h2 className="section-title">Book Airport Transfer<br />in Zanzibar</h2>
        <p className="section-desc">
          Book a taxi for Airport transfer in Zanzibar at Abeid Amani Karume International Airport for instant arrivals. No Waiting time and No worries.
        </p>
      </div>
      <div className="booking-types-grid">
        {BOOKING_TYPES.map(bt => (
          <div className="booking-type-card" key={bt.title}>
            <div className="bt-img">
              <img src={bt.img} alt={bt.title} onError={e => e.target.style.background = "#1a1a1a"} />
              <div className="bt-img-overlay" />
            </div>
            <div className="bt-body">
              <span className="bt-icon">{bt.icon}</span>
              <div className="bt-title">{bt.title}</div>
              <div className="bt-desc">{bt.desc}</div>
              <a href="#" className="bt-link">{bt.link}</a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ─── FOOTER ─── */
function Footer() {
  const quick = ["About Us","Contact Us","Site Map","FAQ","Terms & Conditions"];
  const services = ["Airport Pickup","Private Transfer","Group Booking","Family Transfer","Hotel Transfers"];
  const vehicles = ["Toyota Hiace","Coaster Bus","Toyota Alphard","Toyota Noah","View All Fleet"];
  return (
    <footer>
      <div className="footer-grid">
        <div>
          <div className="footer-brand-name">Zanzibar<span>Transfer</span></div>
          <p className="footer-desc">A popular Travel Agency in Zanzibar providing the most reliable Airport Pickup and transfer services at affordable costs.</p>
          <div className="footer-contact">
            📍 Abeid Amani Karume International Airport, Zanzibar<br />
            📞 <a href="tel:+255745593330">+255 745 593 330</a><br />
            ✉ <a href="mailto:info@therockaIslandtours.com">info@therockaIslandtours.com</a>
          </div>
          <div className="socials">
            {["f","in","t","📷"].map(s => <a key={s} href="#" className="social-icon">{s}</a>)}
          </div>
        </div>
        <div>
          <div className="footer-col-title">Quick Links</div>
          <ul className="footer-links">{quick.map(l => <li key={l}><a href="#">{l}</a></li>)}</ul>
        </div>
        <div>
          <div className="footer-col-title">Services</div>
          <ul className="footer-links">{services.map(l => <li key={l}><a href="#">{l}</a></li>)}</ul>
        </div>
        <div>
          <div className="footer-col-title">Vehicles</div>
          <ul className="footer-links">{vehicles.map(l => <li key={l}><a href="#">{l}</a></li>)}</ul>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-copy">© ZanzibarAirportPickup 2026 · All Rights Reserved</div>
        <div className="footer-powered">Powered by <strong>Orisys Infotech Pvt. Ltd</strong></div>
      </div>
    </footer>
  );
}



/* ─── ROOT ─── */
export default function TransferBooking() {

  const [settings, setSettings] = useState({
    site_name: "-Fleet"
  });
  // Inject CSS once
  useEffect(() => {
    const id = "zanzibar-styles";
    if (!document.getElementById(id)) {
      const style = document.createElement("style");
      style.id = id;
      style.textContent = CSS;
      document.head.appendChild(style);
    }
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

  return (
    <div>
      {/* <Nav /> */}
      <Navbar activePage="Home" siteName={settings?.site_name} />
      <Hero />

      <div style={{ height: 70 }} />
      <div className="gold-divider"><div className="gold-divider-icon" /></div>

      <div className="section-header">
        <div className="section-eyebrow">Our Service</div>
        <h2 className="section-title">Zanzibar Airport Pickup<br />&amp; Transfer Service</h2>
        <p className="section-desc">
          We provide Zanzibar Airport Pickup service in a reliable and cost-effective way. Rent a taxi with a professional driver for your Airport transfer in Zanzibar for any private tour, business tour, or a family tour.
        </p>
      </div>

      <Features />
      <Vehicles />
      <CTABand />
      <BookingTypes />
      <Footer />
    </div>
  );
}